<router-outlet></router-outlet>
<div class="d-flex justify-content-center">
  <div class="attentionPlease">Attention please! All products Images are given as demo- products for non-commercial use.</div>
</div>
